var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navigation"},[_c('div',{staticClass:"navMain myMain"},[_c('div',{staticClass:"logo",on:{"click":_vm.scrollTop}},[_c('img',{attrs:{"src":_vm.logoUrl,"alt":"LUNA AI"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }